export default __webpack_public_path__ + "images/0x7d016eec9c25232b01f23ef992d98ca97fc2af5a.png";